import { FlexBox, Text } from '@fable/components'
import { css, cx } from '@fable/theme'
import { AuthorStat } from 'app/webview/pages/stats_profile/lib/types'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

interface Props extends AuthorStat {
  max: number
}

export const AuthorsGridBar = ({ count, max }: Props) => {
  const theme = useStatsTheme((s) => s.theme)
  const gridBarCount = count * 10
  const gridBarWidth = gridBarCount > 100 ? 100 : gridBarCount

  return (
    <div
      className={css`
        grid-column: 1 / ${max + 1};
        background-color: ${theme.colors.section.chart.ghost};
        border-radius: 6px;
        position: relative;
        overflow: hidden;
      `}
    >
      <div
        className={css`
          display: block;
          width: ${gridBarWidth}%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        `}
      >
        <FlexBox
          className={cx(
            'anim__authors-bar',
            'stats-authors-grid-bar',
            css`
              position: absolute;
              bottom: 0;
              left: 0;
              width: 0%;
              height: 100%;
              background-color: ${theme.colors.primary};
              border-radius: 6px;
              will-change: width;
            `
          )}
          alignItems="center"
          justifyContent="flex-end"
        >
          <Text
            className={cx(
              'anim__authors-text',
              css`
                width: 50px;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                opacity: 0;
                will-change: opacity;
              `,
              count > 2
                ? css`
                    right: 7px;
                  `
                : css`
                    right: -57px;
                  `
            )}
            type="label"
            sizing="S"
            color={
              count > 2 ? theme.colors.section.bg : theme.colors.section.text
            }
            align={count > 2 ? 'right' : 'left'}
            weight="500"
          >
            {count} {count > 1 ? 'books' : 'book'}
          </Text>
        </FlexBox>
      </div>
    </div>
  )
}
